import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-panel-stripe-googlepay',
  templateUrl: './payment-panel-stripe-googlepay.component.html',
})
export class PaymentPanelStripeGooglepayComponent {}
